import * as React from "react";
import { Tooltip } from "azure-devops-ui/TooltipEx";

export default class OverflowTooltipExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <Tooltip overflowOnly={true}>
                    <div
                        style={{
                            width: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}
                    >
                        This text will overflow, rendering a tooltip on hover
                    </div>
                </Tooltip>
            </div>
        );
    }
}
